module.exports = __webpack_public_path__ + "static/img/好评-默认状态@4x.a8f8699b.png";